import React, { useReducer, useEffect } from "react";
import { getIn } from "immutable";
import { FormControl, Input } from "components";
import Bindings from "./Bindings";

const CustomText = ({
	context,
	className = "",
	label,
	path,
	min = 0.5,
	max = 2,
	hasColor,
	hasNumber = true,
	hasWeight = false, // or the default weight value
	onFocus,
	onBlur,
	withSwitch,
	labelColor,
	marginBottom,
	info,
	text,
	isSingleCol,
	bindings,
	indicator
}) => {
	const { state, setItem, validationErrors } = context;
	const textPAth = path + ".text";
	const fontSizePath = path + ".font_size";
	const fontWeightPath = path + ".font_weight";
	const colorPath = path + ".color";
	const withWeight = hasWeight ? {
		value: getIn(state, fontWeightPath.split(".")) || hasWeight,
		onChange: (e) => {
			// setItem(fontWeightPath, JSON.parse(e.target.value)); editable with arrows only
		},
		onClick: (value) => {
			if (value >= 100 && value <= 900)
				setItem(fontWeightPath, JSON.parse(value));
		},
		min: 100,
		max: 900,
		step: 100
	} : undefined
	const withNumber = hasNumber
		? {
			value: getIn(state, fontSizePath.split(".")),
			onChange: (e) => {
				if (e.target.value >= min && e.target.value <= max)
					setItem(fontSizePath, JSON.parse(e.target.value));
			},
			onClick: (value) => {
				try {
					if (value >= min && value <= max)
						setItem(fontSizePath, JSON.parse(value.toFixed(2)));
				} catch (e) {

				}

			},
			icon: { char: "PX" },
			min,
			max,
			step: 1
		}
		: undefined;
	const withColor = hasColor
		? {
			value: getIn(state, colorPath.split(".")),
			onChange: (value) => setItem(colorPath, value)
		}
		: false;

	return (
		<FormControl
			label={label}
			info={info}
			className={className}
			error={validationErrors[textPAth] || validationErrors[fontSizePath]}
			labelColor={labelColor}
			withSwitch={withSwitch}
			marginBottom={marginBottom}
			isSingleCol
		>
			<Input
				type="text"
				BindToContext={[context, textPAth]}
				{...{
					onFocus,
					onBlur,
					withColor,
					withNumber,
					withWeight,
					indicator
				}}
			/>
			{
				bindings && <Bindings {...bindings} />
			}
		</FormControl>
	);
};

export default CustomText;
